import { Component } from '@angular/core';
import { AlertController, LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { ProvidersServices } from "../../../providers/services";
import { IngredientsServices } from "../../services";
import { Globals } from "../../../../globals";
import { DeliberyNoteServices } from "../../../delibery_note/services";
import { FinishProcessPage } from '../../../finish-process/finish-process';
import { StaticsServices } from '../../../services/statics';
import { ProductsServices } from '../../../products/services';
import { TranslateService } from '@ngx-translate/core';
import { StockListPage } from '../../../stock/stock-list/stock-list';

/**
 * Generated class for the IngredientCreateProviderPricePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-ingredient-create-provider-price',
  templateUrl: 'ingredient-create-provider-price.html',
})
export class IngredientCreateProviderPricePage {
  term: string;
  ingredient_measurement: any;
  ingredient_uid: string;
  update_state: boolean = false;
  price_static: any;
  provider_static: any;
  ingredient_name: any;

  show_alert: boolean = true;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    private toastCtrl: ToastController,
    public providersServices: ProvidersServices,
    public ingredientsServices: IngredientsServices,
    public globals: Globals,
    public deliberyNoteServices: DeliberyNoteServices,
    public staticsServices: StaticsServices,
    public productsServices: ProductsServices,
    public translate: TranslateService,
    private alertCtrl: AlertController,) {

    //this.ingredientsServices.getList(this.globals.restaurant_uid);
    this.ingredient_measurement = this.navParams.get('ingredient_measurement');
    this.ingredient_uid = this.navParams.get('ingredient_uid');
    this.update_state = this.navParams.get('update_state');
    this.ingredient_name = this.navParams.get('ingredient_name');

  }

  ionViewCanLeave(): Promise<void> {
    return new Promise((resolve, reject) => {
      //Si el show_alert es true i no estem fen un update al plat
      if (this.show_alert && !this.update_state) {
        let alert = this.alertCtrl.create({
          title: this.translate.instant('general-atencion'),
          message: this.translate.instant('general-salir-proceso-creacion'),
          subTitle: this.translate.instant('general-se-eliminara-elemento'),
          buttons: [
            {
              text: this.translate.instant('general-no'),
              role: 'cancel',
              handler: () => {
                this.globals.side_menu_active = 'stock';
                reject();
              },
            },
            {
              text: this.translate.instant('general-si'),
              handler: () => {
                this.ingredientsServices.afs.collection('ingredients').doc(this.ingredient_uid).delete();
                resolve();
                this.navCtrl.setRoot(StockListPage);
              },
            },
          ],
        });
        alert.present();
      } else {
        resolve();
      }
    });
  }

  calculateRow(index) {
    var price_notax = this.providersServices.providers_array_tmp[index][11];
    var tax = this.providersServices.providers_array_tmp[index][12];
    //var price = this.providersServices.providers_array_tmp[index][13];
    var $total = price_notax + (price_notax * tax / 100);

    this.providersServices.providers_array_tmp[index][13] = $total;
    //posar el mateix impost a tots els inputs de impost
    this.tax4All(index);

  }

  tax4All(index) {
    for (let provider of this.providersServices.providers_array_tmp) {
      provider[12] = this.providersServices.providers_array_tmp[index][12];

      var price_notax = provider[11];
      var tax = provider[12];
      var $total = price_notax + (price_notax * tax / 100);

      provider[13] = $total;
    }
  }

  callToast() {
    let toast = this.toastCtrl.create({
      message: this.translate.instant('instant-ingrediente-creado-correctamente'),
      duration: 3000,
      position: 'top'
    });
    toast.present();
  }

  delete(index) {
    this.providersServices.providers_array_tmp.splice(index, 1);
  }

  update() {
    this.show_alert = false;
    var _array = Array();
    for (var i = 0; this.providersServices.providers_array_tmp.length > i; i++) {
      //agafar el predeterminat
      if (this.providersServices.providers_array_tmp[i][10]) {
        this.price_static = this.providersServices.providers_array_tmp[i][11];
        this.provider_static = this.providersServices.providers_array_tmp[i][1];
      }

      _array.push({
        uid: this.providersServices.providers_array_tmp[i][0],
        default: this.providersServices.providers_array_tmp[i][10],
        price_static: this.providersServices.providers_array_tmp[i][11],
        name_static: this.providersServices.providers_array_tmp[i][1],
        pricetotal_static: this.providersServices.providers_array_tmp[i][13],
        tax_static: this.providersServices.providers_array_tmp[i][12],
        updated_at: new Date(),
      });
    }


    if (_array.length > 0) { //Controlamos que en array tenga como minimo algun elemento.
      this.ingredientsServices.afs.collection('ingredients').doc(this.ingredient_uid).update({
        'providers': _array,
        'price_static': this.price_static,
        'provider_static': this.provider_static,
        'updated_user': this.globals.user_name,
        'updated_at': new Date(),
      }).then(() => {
        if (this.update_state) {
          this.globals.GAtrackView('Ingredients', 'Ingredients - Provider price - Update', this.globals.restaurant.email, 'Create/Update', 'Update provider price', 'Ingredients', this.ingredient_name);
        } else {
          this.globals.GAtrackView('Ingredients', 'Ingredients - Provider price - Create', this.globals.restaurant.email, 'Create/Update', 'Create provider price', 'Ingredients', this.ingredient_name);
        }
        //dataSet
        this.globals.dataSet('ingredient_price', this.price_static, '', this.ingredient_name);
        //quick_create_type (basico / compuesto)
        if (this.ingredientsServices.quick_create) {
          if (this.ingredientsServices.quick_create_type) {//Quick create en caso de ingrediente basico(Este si funciona)
            //ponemos a false los quick_create
            this.ingredientsServices.quick_create = false;
            this.ingredientsServices.quick_create_type = false;
            //hacemos lo que se necesite
            this.deliberyNoteServices.getListPartialSelect(this.globals.restaurant_uid);
            this.productsServices.getListPartialSelect(this.globals.restaurant_uid);
            //llamamos al toast
            this.callToast();
            //pops para que nos devuelva a la pagina correcta
            this.navCtrl.pop();
            this.navCtrl.pop();
            this.navCtrl.pop();
            this.navCtrl.pop();
            this.navCtrl.pop();

          } else {
            //Quick create en caso de ingrediente compuesto (Ya no vale porque no hacemos quick create de ingrediente compuesto) 
            //nunca entrara en el else
            this.callToast();
            this.ingredientsServices.quick_create = false;
            if (this.ingredientsServices.quick_create_dish) {
              this.ingredientsServices.quick_create_dish = false;
              this.navCtrl.pop();
              this.navCtrl.pop();
              this.navCtrl.pop();
              this.navCtrl.pop();
              this.navCtrl.pop();
            } else {
              this.navCtrl.pop();
              this.navCtrl.pop();
              this.navCtrl.pop();
              this.navCtrl.pop();
              this.navCtrl.pop();
              this.navCtrl.pop();
              this.navCtrl.pop();
            }

          }
        } else {
          if (this.update_state) {
            this.staticsServices.changeStateStaticWait(true);
            this.navCtrl.remove(this.navCtrl.getPrevious().index);
            this.navCtrl.pop();
          } else {
            this.navCtrl.push(FinishProcessPage, {
              uid_element: this.ingredient_uid,
              type: 'ingredient'
              //update: this.update_state,
            })
          }
        }

      });
    } else {
      if (this.ingredientsServices.quick_create) {
        if (this.ingredientsServices.quick_create_type) {
          this.ingredientsServices.quick_create = false;
          this.ingredientsServices.quick_create_type = false;
          this.navCtrl.pop();
          this.navCtrl.pop();
          this.navCtrl.pop();
          this.navCtrl.pop();

        } else {
          this.ingredientsServices.quick_create = false;
          this.navCtrl.pop();
          this.navCtrl.pop();
          this.navCtrl.pop();
          this.navCtrl.pop();
          this.navCtrl.pop();
          this.navCtrl.pop();
          this.navCtrl.pop();
        }

      } else {
        this.navCtrl.push(FinishProcessPage, {
          uid_element: this.ingredient_uid,
          type: 'ingredient'
          //update: this.update_state,
        })
      }
    }

  }
}



// WEBPACK FOOTER //
// ./src/pages/ingredients/ingredient-create/ingredient-create-provider-price/ingredient-create-provider-price.ts